import request from '@/utils/request'

export function selectAmountByCustomer(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/orderManagement/selectAmountByCustomer?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}


export function selectAmountByCustomerInfo(data) {
    return request({
        url: `api/serviceCenter/orderManagement/selectAmountByCustomerInfo`,
        method: 'post',
        data,
    })
}


export function downLoadAmountByCustomerInfo(data) {
    return request({
      url: `api/serviceCenter/orderManagement/downLoadAmountByCustomerInfo`,
      method: 'post',
      responseType: 'blob',
      data
    })
  }